import {
  LicenseStatus,
  ModalService,
  Tenant,
  WebAppCommonModule,
} from "@allbesmart/web-app-common";
import {
  UserRole,
  WebAppKeycloakAuthModule,
} from "@allbesmart/web-app-keycloak-auth";
import { DatePipe, NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LICENSE_STATUS_CONFIG } from "src/app/configs/license-status-config";
import { AvailableRoutes } from "../../enums/available-routes";
import { ConfigurationFilesModalComponent } from "../../modals/configuration-files-modal/configuration-files-modal.component";
import { DeleteDeploymentWarningModalComponent } from "../delete-deployment-warning-modal/delete-deployment-warning-modal.component";
import { OaiboxTelemetryComponent } from "../oaibox-telemetry/oaibox-telemetry.component";

@Component({
  selector: "oaibox-client-row",
  templateUrl: "./client-row.component.html",
  styleUrls: ["./client-row.component.css"],
  imports: [
    WebAppCommonModule,
    WebAppKeycloakAuthModule,
    NgClass,
    OaiboxTelemetryComponent,
    DatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientRowComponent {
  @Input({ required: true }) public tenant!: Tenant;

  protected readonly LICENSE_STATUS_CONFIG = LICENSE_STATUS_CONFIG;
  protected readonly LicenseStatus = LicenseStatus;

  protected readonly UserRole = UserRole;

  public expanded: boolean = true;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: ModalService
  ) {}

  protected updateClient(): void {
    this.router.navigate([this.tenant.id, AvailableRoutes.UPDATE_DEPLOYMENT], {
      relativeTo: this.activatedRoute,
    });
  }

  protected deleteTenant(): void {
    this.modalService.pushModal({
      component: DeleteDeploymentWarningModalComponent,
      inputs: new Map<string, any>([["tenant", this.tenant]]),
      closeButtonColor: "white",
    });
  }

  protected goToGnbCustomConfiguration(): void {
    this.router.navigate(
      [this.tenant.id, AvailableRoutes.GNB_CUSTOM_CONFIGURATION],
      { relativeTo: this.activatedRoute }
    );
  }

  protected goToConfigurationFiles(): void {
    this.modalService.pushModal({
      component: ConfigurationFilesModalComponent,
      inputs: new Map<string, any>([["tenant", this.tenant]]),
      size: "large",
    });
  }
}
